import React, { Component } from "react";
import HomeWorkProject from "./HomeWorkProject";
import projectData from "../../../project_data";
import "../../../styles/pages/home/HomeWork.css";

export default class HomeWork extends Component {
  render() {
    return (
      <div className="HomeWork gutters">
        <div className="g-title on-scroll-anim">OUR WORK</div>
        <div className="project-container">
          {projectData.map((project, index) => (
            <HomeWorkProject
              key={index}
              name={project.name}
              link={project.link}
              subText={project.subText}
              image={project.image}
              color={project.color}
            />
          ))}
        </div>
      </div>
    );
  }
}
